var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',[_c('div',{attrs:{"id":"auth-ui"}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }